import { render, staticRenderFns } from "./deleteSmallWechat.vue?vue&type=template&id=4a7d16b6&scoped=true"
import script from "./deleteSmallWechat.vue?vue&type=script&lang=js"
export * from "./deleteSmallWechat.vue?vue&type=script&lang=js"
import style0 from "./deleteSmallWechat.vue?vue&type=style&index=0&id=4a7d16b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d16b6",
  null
  
)

export default component.exports